<kui-modal size="lg" class="details-modal" [class.multiple]="videos.length + photos.length > 1" [title]="title" (onClose)="detachModal()">
    <div class="videos d-flex flex-wrap">
        @for (video of videos; track video; let i = $index) {
            <key-video
                class="video"
                [asset]="asset"
                [video]="video"
                [muted]="i !== 0 || isIOS"
                (onLoaded)="onVideoLoaded($event)"
                (onProgress)="onVideoProgress($event)"
                (onStatusChanged)="onVideoStatusChanged($event)"
            >
            </key-video>
        }
    </div>

    <div class="photos d-flex flex-wrap">
        @for (photo of photos; track photo; let i = $index) {
            <div class="photo">
                <img class="w-100" [src]="photo.url" />
                <a kui-button class="download" [href]="photo.url">
                    <kui-icon name="download"></kui-icon>
                    <span class="d-sm-inline-block ml-2">{{ "DIALOG.DOWNLOAD" | translate }}</span>
                </a>
            </div>
        }
    </div>

    @if (videos.length > 0) {
        <kui-progress class="inline-progress" [value]="progress" type="primary" canSeek="true" (onSeek)="onSeek($event)"></kui-progress>
    }
    <div class="modal-footer d-flex">
        @if (showPlaybackControls) {
            <div class="media-playback d-flex flex-1">
                @if (videos.length > 0) {
                    <div class="playback-bar overflow-hidden">
                        <div class="playback-bar__item">
                            <kui-icon kui-action name="step-backward" (click)="onPlaybackAction('start')" size="sm"></kui-icon>
                        </div>
                        <div class="playback-bar__item">
                            <kui-icon kui-action name="backward" (click)="onPlaybackAction('backward')" size="sm"></kui-icon>
                        </div>
                        <div kui-action class="playback-bar__item">
                            @if (!isPlaying) {
                                <kui-icon name="play" (click)="onPlaybackAction('play')" size="sm"></kui-icon>
                            }
                            @if (isPlaying) {
                                <kui-icon name="pause" (click)="onPlaybackAction('pause')" size="sm"></kui-icon>
                            }
                        </div>
                        <div class="playback-bar__item">
                            <kui-icon kui-action name="forward" (click)="onPlaybackAction('forward')" size="sm"></kui-icon>
                        </div>
                        <div class="playback-bar__item">
                            <kui-icon kui-action name="step-forward" (click)="onPlaybackAction('end')" size="sm"></kui-icon>
                        </div>
                    </div>
                }
                @if (videos.length > 0) {
                    <div class="time-bar d-flex flex-1">
                        <span class="current-time">{{ currentTime }}</span>
                        <kui-progress class="flex-1 pl-2 pr-2" [value]="progress" type="primary" canSeek="true" (onSeek)="onSeek($event)"></kui-progress>
                        <span class="duration-time">{{ durationTime }}</span>
                    </div>
                }
            </div>
        }
        <div>
            <button kui-button [color]="'primary'" (click)="detachModal()">
                <kui-icon name="times"></kui-icon>
                <span class="d-sm-inline-block ml-2"> {{ "DIALOG.CLOSE" | translate }}</span>
            </button>
        </div>
    </div>
</kui-modal>
